exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dv-benutzer-list.table-responsive tr.header-row th.row-nachname,.dv-benutzer-list.table-responsive tr.header-row th.row-vorname{width:14%}.dv-benutzer-list.table-responsive tr.header-row th.row-benutzerrolle{width:17%}.dv-benutzer-list.table-responsive tr.header-row th.row-email{width:18%}.dv-benutzer-list.table-responsive tr.header-row th.row-telefon{width:10%}.dv-benutzer-list.table-responsive tr.header-row th.row-status{width:7%}.dv-benutzer-list.table-responsive tr.header-row th.row-sprache{width:5%}.dv-benutzer-list.table-responsive tr.header-row th.row-action{width:4%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/app/core/component/dv-benutzer-list/dv-benutzer-list.scss
// module id = nQtD
// module chunks = 0